export default "__VITE_ASSET__C_fb0CEy__"